// src/store/modules/statistics/safetyStatistic/options.js

function getThemeValue(name, fallback = '#ff00ff') {
	const root = document.documentElement;
	const value = getComputedStyle(root).getPropertyValue(name).trim();

	if (!value) {
		console.warn(`❌ CSS var ${ name } not found, using fallback ${ fallback }`);
	}
	return value || fallback;
}

export default function getChartOptionsSafetyStatistic() {
	const ticks = {
		color: getThemeValue('--chart-text-color', '#999'),
		font: {
			size: 14,
			weight: 'bold',
			lineHeight: '20px',
		},
	};

	return {
		responsive: true,
		maintainAspectRatio: false,
		interaction: { intersect: false },
		plugins: {
			tooltip: {
				intersect: false,
				backgroundColor: getThemeValue('--chart-tooltip-bg', '#1C1C28'),
				borderColor: getThemeValue('--chart-tooltip-bg', '#1C1C28'),
				borderWidth: 1,
				titleFont: { size: 0, weight: 'bold', lineHeight: 0 },
				bodyFont: { size: 14 }
			},
			legend: { display: false }
		},
		animations: {
			radius: {
				duration: 400,
				easing: 'linear',
				loop: (context) => context.active
			}
		},
		scales: {
			x: {
				stacked: true,
				ticks
			},
			a: {
				position: 'left',
				beginAtZero: true,
				stacked: true,
				ticks,
				grid: {
					borderColor: getThemeValue('--chart-grid-color', 'rgba(255,255,255,0.2)'),
					color: getThemeValue('--chart-grid-color', 'rgba(255,255,255,0.2)'),
				},
			},
			b: {
				position: 'right',
				ticks,
				beginAtZero: true,
				stacked: true,
				grid: {
					borderColor: getThemeValue('--chart-grid-color', 'rgba(255,255,255,0.2)'),
					color: getThemeValue('--chart-grid-color', 'rgba(255,255,255,0.2)'),
				},
			},
		},
	};
}
